export enum DataExportRequestTypes {
  GetDataExportSettingsRequest = 'data.export.settings.get.request',
  GetDataExportSettingsSuccess = 'data.export.settings.get.success',
  GetDataExportSettingsFailure = 'data.export.settings.get.failure',
  UpdateDataExportSettingsRequest = 'data.export.settings.update.request',
  UpdateDataExportSettingsSuccess = 'data.export.settings.update.success',
  UpdateDataExportSettingsFailure = 'data.export.settings.update.failure',
}

export enum DataExportActionTypes {
  UpdateDataExportSettings = 'data.export.settings.updated',
}
